import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import TwitterIcon from '@mui/icons-material/Twitter';
import { Box, Container, Divider, IconButton, Link, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 3, md: 4 },
        px: { xs: 2, md: 2 },
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        position: 'relative',
        zIndex: 10,
        boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: { xs: 4, md: 3 },
          }}
        >
          <Box sx={{ textAlign: { xs: 'center', md: 'left' }, width: { xs: '100%', md: 'auto' } }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1,
                justifyContent: { xs: 'center', md: 'flex-start' },
              }}
            >
              <MusicNoteIcon color="primary" />
              <Typography variant="h6" color="primary">
                Jukobox
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Votre plateforme de musique en ligne
            </Typography>
            <Box
              sx={{ display: 'flex', gap: 1, justifyContent: { xs: 'center', md: 'flex-start' } }}
            >
              <IconButton
                color="primary"
                size="small"
                sx={{
                  backgroundColor: 'rgba(255, 107, 107, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 107, 107, 0.2)',
                  },
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                color="primary"
                size="small"
                sx={{
                  backgroundColor: 'rgba(255, 107, 107, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 107, 107, 0.2)',
                  },
                }}
              >
                <TwitterIcon />
              </IconButton>
              <IconButton
                color="primary"
                size="small"
                sx={{
                  backgroundColor: 'rgba(255, 107, 107, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 107, 107, 0.2)',
                  },
                }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                color="primary"
                size="small"
                sx={{
                  backgroundColor: 'rgba(255, 107, 107, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 107, 107, 0.2)',
                  },
                }}
              >
                <EmailIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: { xs: 4, md: 1 },
              justifyContent: 'center',
              width: { xs: '100%', md: 'auto' },
            }}
          >
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Liens utiles
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Link
                  component={RouterLink}
                  to="/cgv"
                  color="text.secondary"
                  underline="hover"
                  sx={{
                    transition: 'color 0.3s ease',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  CGV
                </Link>
                <Link
                  component={RouterLink}
                  to="/mentions-legales"
                  color="text.secondary"
                  underline="hover"
                  sx={{
                    transition: 'color 0.3s ease',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  Mentions légales
                </Link>
                <Link
                  component={RouterLink}
                  to="/faq"
                  color="text.secondary"
                  underline="hover"
                  sx={{
                    transition: 'color 0.3s ease',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  FAQ
                </Link>
              </Box>
            </Box>

            <Box sx={{ textAlign: { xs: 'center', md: 'right' } }}>
              <Typography variant="subtitle2" color="primary" gutterBottom>
                Contact
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Email: support@jukebox.com
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Support client: 7j/7
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Tél: +33 (0)1 23 45 67 89
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: { xs: 2, md: 3 }, borderColor: 'rgba(0, 0, 0, 0.05)' }} />

        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{
            fontSize: '0.875rem',
            opacity: 0.8,
          }}
        >
          © {new Date().getFullYear()} Jukobox. Tous droits réservés.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
